import ProductsInfoCard from './ProductsInfoCard';

export default ProductsInfoCard;
